<script>
import axios from 'axios'
import nprogress from 'nprogress/nprogress'
export default {
  components: {},
  data() {
    return {
      uid: '',
      token: '',
      confirmationError: false,
      confirmationSuccess: false,
    }
  },
  page: {
    title: 'Confirm',
    meta: [{ name: 'description', content: 'The Confirm page.' }],
  },
  mounted() {
    nprogress.start()
    this.confirmationError = false
    if (this.$route.params.uid && this.$route.params.token)
      axios
        .post('/api/v1/email_confirmation/confirm/', {
          uid: this.$route.params.uid,
          token: this.$route.params.token,
        })
        .then((res) => {
          this.confirmationSuccess = true
          this.$router.push({
            name: 'safehaven-login',
            params: { messageProp: 'Email confirmation is successful!' },
          })
        })
        .catch((err) => {
          this.confirmationError = true
          console.warn(err)
        })
        .finally(() => {
          nprogress.done()
        })
  },
}
</script>

<template>
  <div :class="$style.container">
    <div v-if="confirmationError" class="mt-5">
      Something Went Wrong! Email link expired or invalid.
    </div>
    <div v-else> Loading... </div>
    <div v-if="confirmationSuccess">
      <h1>Confirmation Info</h1>
      <h2>Confirmation Succeeded.</h2>
      <p>You can now navigate to log in</p>
      <router-link to="/safehaven/login" tag="button">Log in</router-link>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  justify-content: center;
}
</style>
